import React from "react";
import { EmailInput } from "@components/Auth/Form/Email";
import { PasswordInput } from "@components/Auth/Form/Password";
import { Box } from "@edreamsodigeo/prisma-design-system";

import type { AuthInputGroupProps } from "./contract";

const AuthInputGroup: React.FC<AuthInputGroupProps> = ({
  email,
  setEmail,
  emailValidationError,
  setEmailValidationError,
  password,
  setPassword,
  passwordValidationError,
  setPasswordValidationError,
  loading,
  onEnterSubmit,
  trackingPrefix,
}) => {
  return (
    <Box>
      <EmailInput
        id="id-email-input"
        email={email}
        setEmail={setEmail}
        errors={emailValidationError}
        clearErrors={(): void => setEmailValidationError([])}
        disabled={loading}
        onEnter={onEnterSubmit}
        trackingPrefix={trackingPrefix}
      />
      <Box mb="1x_small" />
      <PasswordInput
        id="id-password-input"
        password={password}
        setPassword={setPassword}
        errors={passwordValidationError}
        clearErrors={(): void => setPasswordValidationError([])}
        disabled={loading}
        onEnter={onEnterSubmit}
        trackingPrefix={trackingPrefix}
      />
    </Box>
  );
};

export default AuthInputGroup;
